module.exports = __webpack_public_path__ + "img/header-weddingRingstrisets.bd0f85a.webp";